module.exports = __webpack_public_path__ + "img/aseguradore_del_este.644e8087.png";